import type { CanvasActionContext } from './textActionExecutors';

/**
 * Pas du compteur d'avancée d'une écriture qui boucle sur ses éléments (#44, décision du
 * 2026-10-22). Le battement de 5 s prouve seulement que l'onglet vit ; ce compteur prouve
 * que SuperDoc avance. Le backend s'en sert pour déclarer bloquée une écriture dont le
 * compteur s'est arrêté (`MUTATION_STALL_WITHOUT_ADVANCE_MS`, `SuperDocCanvasTools.ts`),
 * sans attendre sa borne totale. Un élément sur cinq suffit : une trame WebSocket par
 * élément coûterait 200 trames pour 200 blocs, sans rien apprendre de plus au serveur.
 */
const PAS_DU_COMPTEUR = 5;

/** Publie `faits / total` tous les {@link PAS_DU_COMPTEUR} éléments, et au dernier. */
export function signalerLAvancee(ctx: Pick<CanvasActionContext, 'onChunkCompleted'>, faits: number, total: number): void {
  if (ctx.onChunkCompleted === undefined || total <= 0 || faits <= 0) return;
  if (faits % PAS_DU_COMPTEUR === 0 || faits === total) ctx.onChunkCompleted({ completedUnits: faits, totalUnits: total });
}
